export default {"src":"/_next/static/media/amenityIcon-professional-cleaning.c481823d.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};